<template>
<div class="message-wrap">
    <div class="nav">消息中心</div>
    <div class="message-list">
        <!-- <dl>
            <dt>
                <img src="../../../static/images/message/xtxx.png">
            </dt>
            <dd>
                <h3>系统消息</h3>
                <p>这是最后一条信息的文本14号字66666</p>
            </dd>
        </dl> -->

        <dl v-for="(item,index) in listArr" @click="goMessageuser(item.targetId)" v-show="showBox == 1">
            <dt v-if="item.latestMessage.content.user">
                
                <img :src="item.latestMessage.content.user.portrait" v-if="item.latestMessage.content.user.portrait">
                <img src="../../../static/images/message/userImg1.png" v-else>

                <span v-show="item.unreadMessageCount > 0">{{item.unreadMessageCount}}</span>
            </dt>
            <dt v-else>
                <img src="../../../static/images/message/userImg1.png">
                <span v-show="item.unreadMessageCount > 0">{{item.unreadMessageCount}}</span>
            </dt>
            <dd>
                <!-- <h3 v-if="item.latestMessage.content.user">{{item.latestMessage.content.user.name}}</h3>
                <h3 v-else>优铺顾问</h3> -->
                <h3>优铺顾问</h3>
                <p v-if="item.latestMessage.messageType == 'ImageMessage'">[图片]</p>
                <p v-else-if="item.latestMessage.messageType == 'TextMessage'">{{item.latestMessage.content.content}}</p>
                <p v-else style="font-size: .12rem;">暂不支持查看此消息，请在租铺宝APP上查看。</p>
            </dd>
        </dl>

        <div v-show="showBox == 0">
            <div class="null-data-box">
                <img src="../../../static/images/home/null-data.png">
                <p>暂无消息</p>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import init from "@/assets/rongyun/init";

// import init from "../../../static/js/rongyun/init";
import axios from 'axios';

export default {
    data() {
        return {

            showBox: 1,
       

            // conId: "", //目标id

            listArr: [],
        };
    },
    watch:{
      

    },
    mounted() {

 
        let _this = this;

        let ryToken = localStorage.ryToken;


        // 用户一
        var userInfo = {
            appKey: "6tnym1br6f107", //正试
            // appKey: "c9kqb3rdc231j", //测试
            token: ryToken
        };

        // 获取历史消息
        var callbacks = {
            CONNECTED: function(instance) {
                //获取历史消息
                var conversationTypes = [ RongIMLib.ConversationType.PRIVATE ];
                var count = 150;
                RongIMClient.getInstance().getConversationList({
                  onSuccess: function(list) {
                    console.log('获取会话列表成功', list);

                    _this.listArr = list;

                    console.log(_this.listArr.length);

                    if(_this.listArr.length == 0){
                        _this.showBox = 0;
                    }else{
                        _this.showBox = 1;
                    }

                    // console.log()
                  },
                  onError: function(error) {
                    console.log('获取会话列表失败', error);
                  }
                }, conversationTypes, count);
            },
        };
        // setTimeout(function () {

        init(userInfo, callbacks);


    },
    created() {
        

    },
    methods: {

        goMessageuser(userId){
            // alert(userId);
            // this.$router.push({path:"/messageuser1",query:{targetId: userId}});
            window.location.href="/messageuser?guwenid=" + userId;
        }
        
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.message-wrap{
    width: 7.5rem;
    height: 100vh;
    background: #fbfbfb;
    .nav {
        width: 7.5rem;
        color: #333;
        line-height: .88rem;
        background: #fff;
        text-align: center;
        position: fixed;
        top: 0;
        left: auto;
        z-index: 9;
    }
}

.message-list{
    background: #fbfbfb;
    padding-top: .88rem;
    padding-bottom: 1.2rem;
    dl{
        width: 7.2rem;
        height: 1.72rem;
        margin-left: .3rem;
        background: #fbfbfb;
        dt{
            width: 1rem;
            height: 1rem;
            float: left;
            margin-top: .22rem;
            margin-right: .32rem;
            position: relative;
            img{
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
            }
            span{
                width: .54rem;
                height: .26rem;
                background: #d0021b;
                text-align: center;
                line-height: .26rem;
                color: #fff;
                font-size: .2rem;
                position: absolute;
                right: -.2rem;
                top: .1rem;
                border-radius: 4px;
            }
        }
        dd{
            width: 5.5rem;
            height: 1.72rem;
            border-bottom: 2px solid #f8f8f8;
            float: left;
            h3{
                font-size: .32rem;
                font-weight: 400;
                color: #333;
                line-height: .44rem;
                margin: .3rem 0 .14rem;
            }
            p{
                font-size: .28rem;
                font-weight:400;
                color: #999;
                line-height: .4rem;
            }
        }
    }
}

/*无数据*/
.null-data-box{
    text-align: center;
    margin: 2.6rem 0;
    img{
        width: 1.6rem;
        height: 1.6rem;
    }
    p{
        font-size: .28rem;
        font-weight: 400;
        color: #999;
        line-height: .4rem;
        margin-top: .24rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/mine/message.vue